import { singleton } from "logic/singleton";
const _Parameter = class _Parameter {
  constructor(type, name, title, description, dataType, defaultValue, optional, binding) {
    this._value = { type, name, title, description, dataType, defaultValue, optional, binding };
  }
  get type() {
    return this._value.type;
  }
  get name() {
    return this._value.name;
  }
  get title() {
    return this._value.title;
  }
  get description() {
    return this._value.description;
  }
  get dataType() {
    return this._value.dataType;
  }
  get defaultValue() {
    return this._value.defaultValue;
  }
  get optional() {
    return this._value.optional;
  }
  // screw you eslint, using param.constructor.needsBinding() is ugly
  // eslint-disable-next-line class-methods-use-this
  get needsBinding() {
    return true;
  }
  get binding() {
    return this._value.binding;
  }
  static fromJSON(value) {
    const { type = "value-parameter-v1" } = value;
    const implementingClass = _Parameter.__registrations[type.toLowerCase()];
    if (implementingClass) {
      return implementingClass.fromJSON(value);
    }
    throw new Error(`No class found for type <${type}>`);
  }
  static registerSubtype(type, implementingClass) {
    this.__registrations[type.toLowerCase()] = implementingClass;
  }
  // eslint-disable-next-line class-methods-use-this
  toJSON() {
    throw new Error("Method toJSON has no implementation");
  }
};
_Parameter.__registrations = {};
let Parameter = _Parameter;
const SingletonParameter = singleton("views.logic.parameters.Parameter", () => Parameter);
export default SingletonParameter;
